function initBannerScripts() {
  console.log("run start");

  const $section1 = $(".shopify-section.section:has(.Givonate-Widget)");
  const $section2 = $(".custom-image-gallery-section");
  if (!$section1.length && !$section2.length) return;

  // Top offsets
  const defaultTop = 9.375;
  const stickyTop = 6.25;
  const defaultBottom = 41.583;
  const stickyBottom = 36.458;

  function updateTop() {
    if ($(window).scrollTop() > 0) {
      if ($section1.length) $section1.css("top", stickyTop + "vw");
      if ($section2.length) $section2.css("top", stickyBottom + "vw");
    } else {
      if ($section1.length) $section1.css("top", defaultTop + "vw");
      if ($section2.length) $section2.css("top", defaultBottom + "vw");
    }
  }

  updateTop();
  $(window).off("scroll.initTop").on("scroll.initTop", updateTop);

  // ─────────────────────────────────────────────────────────────
  // Widget footer + custom dropdown
  // ─────────────────────────────────────────────────────────────
  const $widget = $(
    ".shopify-section.section:has(.Givonate-Widget) .Givonate-Widget-amounts",
  );

  if ($widget.length && !$widget.data("footer-added")) {
    // Footer quote
    // $widget.after(
    //   '<div class="Givonate-footer-text">"Whoever saves a life, it is as if they saved all of humanity"</div>',
    // );

    // Trust badges
    $widget.after(
      '<div class="Givonate-custom-footer"><span class="trust-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>256-bit Secure</span><span class="trust-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>Tax Deductible</span></div>',
    );

    // ─── Custom page dropdown ──────────────────────────────────
    if (!$widget.data("dropdown-added")) {
      $widget.data("dropdown-added", true);

      const dropdownLinks = window.pagesDropdownLinks || [];
      const dropdownLabel = window.pagesDropdownLabel || "Choose an appeal";
      const currentUrl = window.location.pathname;

      if (dropdownLinks.length) {
        let optionsHtml = `<option value="" disabled ${!dropdownLinks.some((l) => l.url === currentUrl) ? "selected" : ""}>${dropdownLabel}</option>`;

        dropdownLinks.forEach((link) => {
          const isSelected = link.url === currentUrl ? "selected" : "";
          optionsHtml += `<option value="${link.url}" ${isSelected}>${link.title}</option>`;
        });

        const dropdownHtml = `
          <div class="page_dropdown_wrapper">
            <select class="page_dropdown">
              ${optionsHtml}
            </select>
          </div>
        `;

        $widget.prepend(dropdownHtml);

        $widget.find(".page_dropdown").on("change", function () {
          const url = $(this).val();
          if (url) {
            window.location.href = url;
          }
        });
      }
    }
    // ───────────────────────────────────────────────────────────

    // Mark footer as added
    $widget.data("footer-added", true);
  }

  // Move gallery after footer
  const $section = $(".custom-image-gallery-section");
  const $footer = $(
    ".shopify-section.section:has(.Givonate-Widget) .Givonate-Widget-footer",
  );
  if ($section.length && $footer.length && !$section.data("moved")) {
    $section.insertAfter($footer);
    $section.data("moved", true);
  }

  // Countdown
  $(".dd-countdown__timer").each(function () {
    var $timer = $(this);
    if ($timer.data("countdown-initialized")) return;

    var endDate = new Date($timer.data("end")).getTime();

    function updateCountdown() {
      var now = new Date().getTime();
      var diff = endDate - now;
      if (diff < 0) diff = 0;

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      $timer.find(".dd-days").text(days);
      $timer.find(".dd-hours").text(("0" + hours).slice(-2));
      $timer.find(".dd-minutes").text(("0" + minutes).slice(-2));
      $timer.find(".dd-seconds").text(("0" + seconds).slice(-2));
    }

    updateCountdown();
    var interval = setInterval(updateCountdown, 1000);
    $timer.data("countdown-initialized", interval);
  });

  // ─── Popular label + custom labels on amount buttons ────────
  const labels = window.pagesDonationLabels || [];
  const popularIndex = window.popularindexing || [];
  const popularAmountIndex = Number(popularIndex[0] ?? -1);

  $(".Givonate-Widget-amount").each(function (index) {
    const $btn = $(this);

    if ($btn.data("label-added")) return;
    $btn.data("label-added", true);

    const labelText = labels[index] || "";
    const isPopular = index === popularAmountIndex;

    if (isPopular) {
      $btn.addClass("popular");
    }

    if (labelText || isPopular) {
      $btn.append(`
        <div class="label_wrapper custom">
          ${isPopular ? `<span class="label_status">Popular</span>` : ""}
          <span class="label">${labelText}</span>
        </div>
      `);
    }
  });

  // ─── Active label appended below grid ───────────────────────
  function appendActiveLabel(gridSelector = ".Givonate-Widget-grid") {
    const grid = document.querySelector(gridSelector);
    if (!grid) return;

    const existingLabel = grid.nextElementSibling;
    if (
      existingLabel &&
      existingLabel.classList.contains("active-label-text")
    ) {
      existingLabel.remove();
    }

    const activeBtn = grid.querySelector(".Givonate-Widget-amount-active");
    if (!activeBtn) return;

    const labelText = activeBtn.querySelector(".label")?.textContent.trim();
    if (!labelText) return;

    // const labelDiv = document.createElement("div");
    // labelDiv.className = "active-label-text";
    // labelDiv.textContent = labelText;

    // grid.insertAdjacentElement("afterend", labelDiv);
  }

  document.querySelectorAll(".Givonate-Widget-amount").forEach((button) => {
    button.addEventListener("click", function () {
      const grid = button.closest(".Givonate-Widget-grid");
      grid
        .querySelectorAll(".Givonate-Widget-amount")
        .forEach((btn) =>
          btn.classList.remove("Givonate-Widget-amount-active"),
        );

      button.classList.add("Givonate-Widget-amount-active");
      appendActiveLabel();
    });
  });

  appendActiveLabel();

  // ─── Custom amount input ────────────────────────────────────
  $(document).ready(function () {
    const $wrapper = $("<div>", { class: "custom-amount-wrapper" });
    const $customInput = $("<input>", {
      type: "number",
      class: "custom-amount-input",
      placeholder: "£ Enter a Custom Amount",
      min: 1,
      step: 1,
    });

    $wrapper.append($customInput);
    $(".Givonate-Widget-input").after($wrapper);

    function updateAmountInURL(amount) {
      const url = new URL(window.location.href);

      if (amount && amount > 0) {
        url.searchParams.set("amount", amount);
      } else {
        url.searchParams.delete("amount");
      }

      window.history.replaceState({}, "", url);
    }

    function getAmountFromURL() {
      const params = new URLSearchParams(window.location.search);
      let amount = parseInt(params.get("amount"), 10);

      if (!isNaN(amount) && amount > 0) {
        return amount;
      }
      return null;
    }

    const urlAmount = getAmountFromURL();

    if (urlAmount) {
      $customInput.val(urlAmount);

      const widgetInput = $(".Givonate-Widget-input input")[0];
      if (widgetInput) {
        widgetInput.value = urlAmount;
        widgetInput.dispatchEvent(new Event("input", { bubbles: true }));
        widgetInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    $(document).on("input", ".custom-amount-input", function () {
      let value = Math.floor(parseFloat($(this).val()));

      if (isNaN(value) || value < 1) {
        $(this).val("");
        updateAmountInURL(null);
        return;
      }

      $(this).val(value);

      const input = $(".Givonate-Widget-input input")[0];
      if (input) {
        input.value = value;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      updateAmountInURL(value);
    });

    $(document).on("click", ".Givonate-Widget-amount", function () {
      updateAmountInURL(null);
      $customInput.val("");
    });
  });

  console.log("run end");
}

function waitForWidget(callback) {
  const targetSelector = ".Givonate-Widget-amounts";

  if (document.querySelector(targetSelector)) {
    callback();
    return;
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(targetSelector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

waitForWidget(() => {
  initBannerScripts();
});

// Session attribute tracker (unchanged)
(function () {
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      session: params.get("session"),
      amount: params.get("amount"),
    };
  }

  async function saveSessionToCart(session, amount) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            donation_session: session,
            donation_amount: amount,
          },
        }),
      });

      const result = await response.json();
      console.log("Cart updated:", result);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", async function () {
    const { session, amount } = getUrlParams();

    if (!session) {
      console.log("No session found in URL");
      return;
    }

    console.log("Saving session immediately:", session);

    await saveSessionToCart(session, amount);
  });
})();